export class SelectFilter {
  public index: number | string;
  public displayName: string;

  constructor(displayName: string, index: number | string) {
    this.index = index;
    this.displayName = displayName;
  }
}
